import { render } from "./trivia-option.vue?vue&type=template&id=fbdd501c"
import script from "./trivia-option.vue?vue&type=script&lang=js"
export * from "./trivia-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__